/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { NotificationsSocialUploadNotificationDataDto } from "./NotificationsSocialUploadNotificationDataDto";

export const NotificationsSocialUploadFailedNotificationDtoWorkflowKeyEnum = {
    "social-export_upload-failed": "social-export_upload-failed"
} as const;

export type NotificationsSocialUploadFailedNotificationDtoWorkflowKeyEnumKey = (typeof NotificationsSocialUploadFailedNotificationDtoWorkflowKeyEnum)[keyof typeof NotificationsSocialUploadFailedNotificationDtoWorkflowKeyEnum];

export type NotificationsSocialUploadFailedNotificationDto = {
    /**
     * @description Knock workflow key. Map from the feed item source.key; not part of trigger data.
     * @type string
    */
    workflowKey: NotificationsSocialUploadFailedNotificationDtoWorkflowKeyEnumKey;
    /**
     * @description In-app notification data for social-export_upload-completed and social-export_upload-failed
     * @type object
    */
    data: NotificationsSocialUploadNotificationDataDto;
};